import LeadForm from "@/components/public/LeadForm";
import { usePageMeta } from "@/lib/seo";
import { CheckCircle2 } from "lucide-react";

const BENEFITS = [
  "A live walkthrough tailored to your operation",
  "See live GPS tracking and late-trip prevention in action",
  "Understand driver, fleet and compliance management",
  "Get pricing built around your fleet size",
];

export default function RequestDemoPage() {
  usePageMeta("demo");
  return (
    <div data-testid="request-demo-page">
      <div className="bg-slate-950 pt-36 pb-24 text-white">
        <div className="mx-auto grid max-w-6xl items-start gap-12 px-5 lg:grid-cols-2 lg:px-8">
          <div className="pt-4">
            <p className="text-sm font-semibold uppercase tracking-widest text-blue-400">Request a Demo</p>
            <h1 className="mt-3 font-display text-4xl font-extrabold leading-tight tracking-tight sm:text-5xl">
              See RideStamp in action
            </h1>
            <p className="mt-5 max-w-md text-lg text-slate-300">
              Book a personalized walkthrough and see how RideStamp keeps every ride, driver and
              vehicle accounted for.
            </p>
            <ul className="mt-8 space-y-3.5">
              {BENEFITS.map((b) => (
                <li key={b} className="flex items-start gap-3 text-slate-200">
                  <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-emerald-400" /> {b}
                </li>
              ))}
            </ul>
          </div>
          <div className="rounded-2xl border border-slate-200 bg-white p-7 shadow-2xl lg:p-9">
            <h2 className="font-display text-xl font-bold text-slate-900">Tell us about your operation</h2>
            <p className="mt-1 text-sm text-slate-500">A specialist will reach out to schedule your demo.</p>
            <div className="mt-6">
              <LeadForm type="demo" submitLabel="Request My Demo" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
